/* ========= RC CUSTOM STONE DROPDOWN — LEAD TIME ========= */
(function () {
  'use strict';

  /* ========= Cache: variantId (string) -> { availableToSell, inventory_management, inventory_policy } ========= */
  const cache = {};

  /* ========= Guards to avoid double-attaching listeners ========= */
  let clickListenerAttached   = false;
  let variantListenerAttached = false;

  /* ========= Core label logic ========= */
  function resolveLeadTimeLabel({ availableToSell, inventory_management, inventory_policy, customLeadTime }) {
    const isTracked = !!inventory_management;
    const oversell  = inventory_policy === 'continue';
    const qty       = Number(availableToSell ?? 0);

    if (!isTracked) {
      return { label: 'Made to Order', leadTimeText: customLeadTime || '', className: 'made-to-order' };
    }
    if (qty > 0) {
      return { label: 'In Stock', leadTimeText: '', className: 'in-stock' };
    }
    if (oversell) {
      return { label: 'Made to Order', leadTimeText: customLeadTime || '', className: 'made-to-order' };
    }
    return { label: 'Sold Out', leadTimeText: '', className: 'sold-out' };
  }

  /* ========= Collect all unique stone variant IDs from the DOM  ========= */
  function collectVariantIds() {
    const ids = new Set();
    document.querySelectorAll('.rc-inject-variant-leadtime[data-variant-id]').forEach((el) => {
      const id = el.dataset.variantId?.trim();
      if (id) ids.add(id);
    });
    return [...ids];
  }

  /* ========= POST all stone variant IDs to the API in one request ========= */
  async function fetchStoneLeadTimes(variantIds) {
    if (!variantIds.length) return;
    try {
      const response = await fetch(`${portalApiUrl}/variants-leadtime`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variantIds: variantIds.map(Number) })
      });

      if (!response.ok) throw new Error(`API error ${response.status}`);

      const json  = await response.json();
      const items = Array.isArray(json) ? json : (json.data ?? []);

      items.forEach((item) => {
        cache[String(item.id)] = {
          availableToSell: item.availableToSell ?? 0
        };
      });
      renderAllOptionLabels();

    } catch (err) {
      console.error('[StoneLeadTime] Failed to fetch:', err);
    }
  }

  /* ========= 
    ** Populate .rc-inject-variant-leadtime spans for every stone option **
    ** Called after fetch, and again on every product variant change. **
    ========= */
  function renderAllOptionLabels() {
    document.querySelectorAll('.rc-inject-variant-leadtime[data-variant-id]').forEach((span) => {
      const variantId = span.dataset.variantId?.trim();
      if (!variantId) return;

      const cached = cache[variantId];
      if (!cached) return;

      const resolved = resolveLeadTimeLabel({
        availableToSell:      cached.availableToSell,
        inventory_management: span.dataset.inventoryManagement || null,
        inventory_policy:     span.dataset.inventoryPolicy     || 'deny',
        customLeadTime:       span.dataset.leadTime?.trim()    || ''
      });

      span.className = `rc-inject-variant-leadtime rc-drop-var-leadtime-${variantId} rc-stone-lt-label rc-stone-lt-label--${resolved.className}`;
      span.innerHTML = `<span class="rc-stone-lt-label__status">${resolved.label}</span>`;
      span.removeAttribute('hidden');

      /* ========= Disable the parent option button if SOLD OUT ========= */
      const parentBtn = span.closest('.custom-dropdown__option');
      if (parentBtn) {
        if (resolved.className === 'sold-out') {
          parentBtn.setAttribute('disabled', 'disabled');
          parentBtn.classList.add('rc-option--sold-out');
        } else {
          parentBtn.removeAttribute('disabled');
          parentBtn.classList.remove('rc-option--sold-out');
        }
      }
    });
  }

  /* =========
    ** Render (or update) the selected-state badge below the dropdown 
    ** Trigger of a given stone picker wrapper.                       
    ========= */
  function renderSelectedBadge(wrapper, variantId, liquidLeadTime) {
    let badge = wrapper.querySelector('.rc-stone-selected-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'rc-stone-selected-badge';
      const anchor = wrapper.querySelector('.form-options-wrapper');
      if (anchor) {
        anchor.insertAdjacentElement('afterend', badge);
      } else {
        wrapper.querySelector('.product-form-input')?.appendChild(badge);
      }
    }

    if (!variantId) {
      badge.hidden    = true;
      badge.innerHTML = '';
      return;
    }

    const cached = cache[variantId];
    if (!cached) {
      badge.hidden = true;
      return;
    }

    const opt = document.querySelector(
      `.rc-stone-picker-wrapper .custom-dropdown__option[data-variant-id="${variantId}"]`
    );
    const { label, leadTimeText, className } = resolveLeadTimeLabel({
      availableToSell:      cached.availableToSell, //through API
      inventory_management: opt?.dataset.inventoryManagement || null,                     // through shopify attribute
      inventory_policy:     opt?.dataset.inventoryPolicy     || 'deny',                   // through shopify attribute
      customLeadTime:       liquidLeadTime?.trim() || opt?.dataset.leadTime?.trim() || '' // through shopify attribute
    });

    badge.className = `rc-stone-selected-badge rc-stone-selected-badge--${className}`;
    badge.innerHTML = leadTimeText
      ? `<span class="rc-stone-selected-badge__leadtime">${leadTimeText}</span><div class="rc-lead-bel-drop"><span class="rc-stone-selected-badge__dot"></span><span class="rc-stone-selected-badge__status">${label}</span></div>`
      : `<span class="rc-stone-selected-badge__dot"></span><span class="rc-stone-selected-badge__status">${label}</span>`;
    badge.hidden = false;
  }

  /* ========= Clear the selected badge (called when a picker is hidden) ========= */
  function clearSelectedBadge(wrapper) {
    const badge = wrapper.querySelector('.rc-stone-selected-badge');
    if (!badge) return;
    badge.hidden    = true;
    badge.innerHTML = '';
  }

  /* ========= 
    ** Delegated click listener — fires on every stone option click and 
    ** updates the selected badge for that picker wrapper. 
    ========= */
  function attachClickDelegation() {
    if (clickListenerAttached) return;
    clickListenerAttached = true;

    document.addEventListener('click', (e) => {
      const opt = e.target.closest('.rc-stone-picker-wrapper .custom-dropdown__option.rc-custom-stones-product');
      if (!opt) return;

      const wrapper   = opt.closest('.rc-stone-picker-wrapper');
      const variantId = opt.dataset.variantId?.trim() || '';
      const leadTime  = opt.dataset.leadTime?.trim()  || '';
      renderSelectedBadge(wrapper, variantId, leadTime);
    }, true );
  }

  /* ========= Re-render option labels when the main product variant changes. ========= */
  function attachVariantChangeListeners() {
    if (variantListenerAttached) return;
    variantListenerAttached = true;
    if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      webvista.subscribe(PUB_SUB_EVENTS.variantChange, () => {
        renderAllOptionLabels();
      });
    }
    document.addEventListener('variant:change', () => {
      renderAllOptionLabels();
    });
  }

  /* ========= Initialization function ========= */
  function initialization() {
    const variantIds = collectVariantIds();
    if (!variantIds.length) {
      setTimeout(() => {
        const retryIds = collectVariantIds();
        if (retryIds.length) {
          fetchStoneLeadTimes(retryIds);
          attachClickDelegation();
          attachVariantChangeListeners();
          exposePublicAPI();
        }
      }, 400);
      return;
    }
    fetchStoneLeadTimes(variantIds);
    attachClickDelegation();
    attachVariantChangeListeners();
    exposePublicAPI();
  }

  /* =========
    ** Public API — consumed by the Liquid snippet                        
    ** onOptionSelected: re-render badge after a pick                    
    ** _clearBadge: explicitly clear badge when a picker is hidden  
   ========= */
  function exposePublicAPI() {
    window.rcStoneLeadTime = {
      onOptionSelected: (wrapper, variantId, liquidLeadTime) => {
        renderSelectedBadge(wrapper, variantId, liquidLeadTime);
      },
      _clearBadge: (wrapper) => {
        clearSelectedBadge(wrapper);
      }
    };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialization);
  } else {
    initialization();
  }

})();